import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { useAuth } from '../hooks/useAuth'
import './Login.css'

export default function Login() {
  const { login, loading, error } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    login(email, password)
  }

  return (
    <div className="login-container">
      <div className="login-bg-circle login-bg-circle--top" />
      <div className="login-bg-circle login-bg-circle--bottom" />

      <div className="login-card-wrapper">
        <div className="login-card">
          <div className="login-logo-container">
            <img src="/logo-dsc.png" alt="DSC Travel" className="login-logo" />
          </div>

          <div className="login-header">
            <h1 className="login-title">Bem-vindo de volta</h1>
            <p className="login-subtitle">
              Acesse sua área de atendimento personalizado
            </p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label htmlFor="email" className="login-label">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com.br"
                required
                className="login-input"
              />
            </div>

            <div className="login-field">
              <label htmlFor="password" className="login-label">Senha</label>
              <div className="login-password-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••••••"
                  required
                  className="login-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="login-eye-button"
                  aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="login-forgot-wrapper">
              <button type="button" className="login-forgot-button">
                Esqueceu sua senha?
              </button>
            </div>

            {error && <p className="login-error">{error}</p>}

            <button type="submit" disabled={loading} className="login-submit">
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <div className="login-footer">
            <p className="login-footer-text">
              © DSC Travel • Experiências feitas sob medida
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
